import { useQuery } from "@tanstack/react-query";
import { CircleNotch, DownloadSimple, FileText } from "@phosphor-icons/react";
import { therapistContractQueryOptions } from "@/api-queries/documents";
import { formatDate } from "@/lib/format";
import { apiUrl } from "@/lib/api-url";
import { SectionShell } from "./section-primitives";

/** Prikaz aktivnog ugovora i datuma prihvatanja; prihvata se samo u onboardingu. */
export function ContractSection() {
  const { data: contract, isLoading } = useQuery(therapistContractQueryOptions());

  return (
    <SectionShell
      icon={FileText}
      title="Ugovor o poslovnoj saradnji"
      description="Važeća verzija ugovora koju uređuje Psihotron. Prihvatanje se bilježi uz verziju koju si vidio/la."
    >
      {isLoading ? (
        <div className="flex justify-center py-6">
          <CircleNotch className="size-5 animate-spin text-muted-foreground" />
        </div>
      ) : !contract ? (
        <p className="text-sm text-muted-foreground">Trenutno nema aktivnog ugovora.</p>
      ) : (
        <div className="flex flex-wrap items-center justify-between gap-4 rounded-lg border border-border/60 bg-muted px-4 py-3">
          <div className="text-sm">
            <p className="font-medium text-foreground">{contract.title}</p>
            <p className="text-muted-foreground">
              Verzija {contract.version}, ažurirano {formatDate(contract.updatedAt)}.{" "}
              {contract.acceptedAt
                ? `Prihvaćeno ${formatDate(contract.acceptedAt)} (verzija ${contract.acceptedVersion ?? contract.version}).`
                : "Još nije prihvaćeno."}
            </p>
          </div>
          <a
            href={apiUrl("/api/therapist/contract.pdf")}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-1.5 rounded-lg border border-border bg-card px-3 py-1.5 text-xs font-medium text-foreground transition-colors hover:bg-muted"
          >
            <DownloadSimple className="size-4" />
            Preuzmi PDF
          </a>
        </div>
      )}
    </SectionShell>
  );
}
